
export const productionOrderStates = { "RUNNING": "Running", "PAUSED": "Paused", "CANCELLED": "Cancelled", "STOPPED": "Stopped", "PLANNED": "Planned", "DONE": "Done" }

